<template>
  <article>
    <section>
      <img :src="data.image">
      <p>{{ data.name }}</p>
      <span>{{ data.subtitle }}</span>
    </section>
  </article>
</template>

<script>
export default {
  props: {
    data: Object
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

article {
  cursor: pointer;
  margin: 15px 0;
  height: 200px;
  border: none;
  background-color: $light;
  transition: 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);

  section {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 28px;
    text-align: center;
    color: #6D6E71;

    img {
      height: 100px;
    }

    p {
      line-height: 0.8;
      font-size: 1.25rem;
    }
  }
}

article:hover {
  section {
    color: white;

    img {
      filter: invert(300%) brightness(1000%);
    }
  }
}
</style>
